import { useEffect, useState } from 'react';
import { schoolImages } from '../data/images';

const navigationItems = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Academics', href: '#academics' },
  { label: 'Gallery', href: '#gallery' },
  { label: 'Contact', href: '#contact' },
  { label: 'Public Disclosure', href: '#mandatory-public-disclosure' },
];

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [currentHash, setCurrentHash] = useState(window.location.hash || '#home');

  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    const updateCurrentHash = () => setCurrentHash(window.location.hash || '#home');
    window.addEventListener('hashchange', updateCurrentHash);
    return () => window.removeEventListener('hashchange', updateCurrentHash);
  }, []);

  return (
    <header className="site-header" id="home">
      <div className="header-inner">
        <a className="brand" href="#home" onClick={closeMenu} aria-label="Shree Umiya Patidar School home">
          <img className="brand-logo" src={schoolImages.logo} alt="Shree Umiya Patidar School emblem" />
          <span className="brand-copy">
            <strong>Shree Umiya Patidar Hr. Sec. School</strong>
            <span>Tillore Khurd</span>
          </span>
        </a>

        <button
          className="menu-toggle"
          type="button"
          aria-expanded={menuOpen}
          aria-controls="primary-navigation"
          onClick={() => setMenuOpen((isOpen) => !isOpen)}
        >
          <span />
          <span />
          <span />
          <span className="sr-only">{menuOpen ? 'Close menu' : 'Open menu'}</span>
        </button>

        <nav className={`primary-navigation${menuOpen ? ' is-open' : ''}`} id="primary-navigation" aria-label="Primary navigation">
          {navigationItems.map((item) => (
            <a
              className={`nav-link${currentHash === item.href ? ' is-active' : ''}`}
              href={item.href}
              key={item.label}
              onClick={closeMenu}
            >
              {item.label}
            </a>
          ))}
          <a className="header-cta" href="#admissions" onClick={closeMenu}>Admissions Open</a>
        </nav>
      </div>
    </header>
  );
}

export { navigationItems };
export default Header;
